import { Grid } from '@mui/material';
import { siteAuditModal } from 'src/common/config/TextMessage';
import { insightCSS } from 'src/content/siteAudit/WebsiteAuditDashboardcomponentes/insightcss';
import { fourthCardCss } from '../siteAuditCSS';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import { Fragment, useEffect, useState } from 'react';
import {
  setCompareDate,
  setFourthCardPdfCheck
} from 'src/redux/siteAuditReducer';
import { pdfContainerSx } from 'src/common/PdfComponents/PdfSxs';
import { timeConverter } from 'src/common/config/FunctionHelper';

/**
 * ForthCardOfTopIssuesPDF component is responsible for rendering the fourth card
 * that displays the top issues in a PDF.
 */
const ForthCardOfTopIssuesPDF = ({
  reportMetaData
}: {
  reportMetaData?: any;
}) => {
  // Get the site ID from the Redux store
  const siteId = useSelector((state: RootState) => state.siteAudit.siteId) ?? 0;
  let compare = useSelector((state: RootState) => state.siteAudit.compare);

  const pdfReportData = useSelector(
    (state: RootState) => state.dashboard.pdfReportData
  );

  // State to store the audit checker count response
  const [auditCheckerCountResponse, setAuditCheckerCountResponse] =
    useState<any>({});
  let compareDate =
    useSelector((state: RootState) => state.siteAudit?.compareDate) ?? 0;
  const currentDate = new Date().getTime();
  let userDetails: any = useSelector(
    (state: RootState) => state.counter.userDetails
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (pdfReportData?.seoTasks?.countDetails) {
      const transformed = {};
      pdfReportData.seoTasks.countDetails.forEach((task, idx) => {
        transformed[idx] = task;
      });
      setAuditCheckerCountResponse(transformed);
      dispatch(setFourthCardPdfCheck(true));
    }
  }, [pdfReportData?.seoTasks]);

  return (
    <>
      <div style={{ ...fourthCardCss.mainBox, border: '1px solid grey' }}>
        <div
          className="flex items-center"
          style={pdfContainerSx?.titleMainBoxSx}
        >
          <p
            style={{
              ...insightCSS.headingLabel,
              ...pdfContainerSx?.seoTasksTitleSx,
              marginRight: '8px',
              fontWeight: 680,
              fontSize: '24px'
            }}
          >
            {siteAuditModal.topIssues}
          </p>
          <div style={pdfContainerSx?.titleSubTextsBoxSx}>
            <div style={pdfContainerSx?.titleSubBoxesSx}>
              <img src="/static/images/icons/alert-circle.svg" alt="icon" />
              <p style={pdfContainerSx?.titleSubBoxesTextsSx}>{'Critical'}</p>
            </div>
            <div style={pdfContainerSx?.titleSubBoxesSx}>
              <img src="/static/images/icons/recommended.svg" alt="icon" />
              <p style={pdfContainerSx?.titleSubBoxesTextsSx}>
                {'Recommended'}
              </p>
            </div>
            <div style={pdfContainerSx?.titleSubBoxesSx}>
              <img src="/static/images/icons/optional.svg" alt="icon" />
              <p style={pdfContainerSx?.titleSubBoxesTextsSx}>{'Optional'}</p>
            </div>
          </div>
        </div>
        <Grid
          container
          spacing={4}
          columnSpacing={{ xs: 3, sm: 3, md: 3 }}
          sx={{ marginTop: '20px' }}
        >
          {Object.keys(auditCheckerCountResponse).map((key, index, array) => (
            <Fragment key={index}>
              <Grid item xs={4} p={2}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '0.625rem'
                  }}
                >
                  {auditCheckerCountResponse[key]?.priority === 'critical' && (
                    <img
                      src="/static/images/icons/alert-circle.svg"
                      alt="icon"
                    />
                  )}
                  {auditCheckerCountResponse[key]?.priority ===
                    'recommended' && (
                    <img
                      src="/static/images/icons/recommended.svg"
                      alt="icon"
                    />
                  )}
                  {auditCheckerCountResponse[key]?.priority === 'optional' && (
                    <img src="/static/images/icons/optional.svg" alt="icon" />
                  )}
                  <p
                    style={{
                      ...pdfContainerSx.titleSx,
                      width: '34.25rem'
                    }}
                  >
                    {auditCheckerCountResponse[key].title}
                  </p>
                </div>
                <div>
                  <Grid item xs={6}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: '10px'
                      }}
                    >
                      <p
                        style={{
                          ...fourthCardCss.valueSx,
                          marginRight: '8px' // Add margin to separate the count and chip
                        }}
                      >
                        {auditCheckerCountResponse[key].count}
                      </p>
                      {auditCheckerCountResponse[key].per !== null && (
                        <div
                          style={{
                            width: '100px',
                            height: '40px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginRight: '8px',
                            marginLeft: '10px'
                          }}
                        >
                          {Number(auditCheckerCountResponse[key]?.per ?? 0) ===
                          0 ? (
                            <div></div>
                          ) : auditCheckerCountResponse[key].per > -1 &&
                            auditCheckerCountResponse[key].per < 1 ? (
                            <img
                              style={{
                                objectFit: 'cover'
                              }}
                              src={
                                process.env.PUBLIC_URL +
                                '/static/images/icons/arrow-up-right-yellow.svg'
                              }
                              alt="icon"
                            />
                          ) : auditCheckerCountResponse[key].sign == '-' ? (
                            <div
                              style={{
                                ...pdfContainerSx?.commonImgIconStyle,
                                height: 'auto'
                              }}
                            >
                              <img
                                src="/static/images/icons/green_up.svg"
                                alt="icon"
                                style={{}}
                              />
                            </div>
                          ) : (
                            <img
                              style={{
                                ...pdfContainerSx?.commonImgIconStyle,
                                objectFit: 'contain'
                              }}
                              src={
                                process.env.PUBLIC_URL +
                                '/static/images/icons/red_down.svg'
                              }
                              alt="icon"
                            />
                          )}
                          {Number(auditCheckerCountResponse[key]?.per ?? 0) !==
                            0 && (
                            <p
                              style={{
                                fontFamily: 'Inter',
                                fontSize: '16px',
                                fontWeight: '600',
                                color:
                                  auditCheckerCountResponse[key].per > -1 &&
                                  auditCheckerCountResponse[key].per < 1
                                    ? 'rgba(240, 134, 75, 1)' // Text color for values between 0.1 and 1
                                    : auditCheckerCountResponse[key].sign == '-'
                                    ? '#25D3B1' // Text color for values greater than 0
                                    : '#F45252', // Default text color
                                marginLeft: '4px' // Adjust the margin to position the percentage text
                              }}
                            >
                              {auditCheckerCountResponse[key].per}
                              {'%'}
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                  </Grid>
                </div>
              </Grid>
              {/* Divider after every 3 items */}
              {(index + 1) % 3 === 0 && index !== array?.length - 1 && (
                <div
                  style={{
                    width: '100%',
                    height: '1px',
                    backgroundColor: 'lightgray'
                  }}
                />
              )}
            </Fragment>
          ))}
        </Grid>
        {compareDate !== 0 && (
          <div
            style={{
              textAlign: 'center',
              ...pdfContainerSx?.compareDateBoxSx
            }}
          >
            <p style={pdfContainerSx?.compareDateTextSx}>
              {` ${timeConverter(
                currentDate,
                userDetails?.date_format ||
                  reportMetaData?.dateFormat ||
                  'DD/MM/YYYY',
                true,
                true
              )}`}
              {' vs '}
              {timeConverter(
                compareDate,
                userDetails?.date_format ||
                  reportMetaData?.dateFormat ||
                  'DD/MM/YYYY',
                true,
                true
              )}
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default ForthCardOfTopIssuesPDF;
